var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-progress-linear',{attrs:{"striped":"","rounded":"","height":"20","value":_vm.percentage,"color":_vm.percentage>99?'success':'warning'}},[(_vm.percentage>99)?[_vm._v(" آپلود شد درحال پردازش ")]:[_vm._v(" "+_vm._s(_vm.percentage)+"% ")]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }